module.exports = __webpack_public_path__ + "img/ic-trans-active.02192033.svg";